// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fz-a";
export var fulfillmentFormRail = "_fz-9";
export var headerTitleRow = "_fz-c";
export var orderDetailsWrapper = "_fz-7";
export var orderLinkTrigger = "_fz-2";
export var paymentInformationGrid = "_fz-h";
export var paymentSummaryColumn = "_fz-i";
export var shipmentContainer = "_fz-b";
export var shipmentDetailsMainPane = "_fz-8";
export var shipmentNavigationCard = "_fz-5";
export var shipmentNavigationRail = "_fz-3";
export var shipmentNavigationRailHeader = "_fz-4";
export var shipmentSummaryFact = "_fz-e";
export var shipmentSummaryGrid = "_fz-d";
export var shipmentSummaryMetadataRow = "_fz-f";
export var shipmentSummaryTags = "_fz-g";
export var shipmentWorkspace = "_fz-0";
export var shipmentWorkspaceContent = "_fz-6";
export var shipmentWorkspaceHeader = "_fz-1";